import wallet from 'assets/images/wallet.svg';
import tick from 'assets/images/tick.svg';
import cross from 'assets/images/cross.svg';
import star from 'assets/images/Star.svg';
import clap from 'assets/images/clapping.svg';
import coin from 'assets/images/coin.svg';
export const matrixDriverData= (details, matrix) => [
    {
        id:1,
        icon:wallet,
        amt:matrix?.totalRide || '0',
        name:"Total Trip"
    },
    {
        id:2,
        icon:tick,
        amt:matrix?.completedRide || '0',
        name:"Completed Trip"
    },
    {
        id:3,
        icon:cross,
        amt:matrix?.cancelRide || '0',
        name:"Canceled Trip"
    },
    // {
    //     id:4,
    //     icon:star,
    //     amt:details?.rating || '',
    //     name:"Total Ratings"
    // },
    {
        id:5,
        icon:clap,
        amt:matrix?.claps || '0',
        name:"Total Claps"
    },
    {
        id:6,
        icon:coin,
        amt:matrix?.totalCreditPoints || '0',
        name:"Total Credit Points"
    }
]

